import {
  Dialog,
  styled,
  useTheme,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import { ReactComponent as FixitLogo } from "../../images/FixitLogo.svg";
// import LogoutIcon from '@mui/icons-material/Logout';
import { useContext, useState } from "react";
import { DrawerOpenContext } from "../../context/DrawerOpenContext";
import { LightDarkModeContext } from "../../context/LightDarkModeContext";

// from MUI 'Mini variant drawer' example (https://mui.com/material-ui/react-drawer/#mini-variant-drawer)

const drawerWidth = 240;

const openAndClosedMixin = (theme, open) => ({
  width: open ? drawerWidth : 0,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...openAndClosedMixin(theme, open),
  "& .MuiDrawer-paper": openAndClosedMixin(theme, open),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  minHeight: "10vh",
}));

export default function Drawer() {
  const open = useContext(DrawerOpenContext);
  const colorMode = useContext(LightDarkModeContext);
  const theme = useTheme();

  const [openContactUsDialog, setOpenContactUsDialog] = useState(false);
  const [openWhatsNewDialog, setOpenWhatsNewDialog] = useState(false);

  const handleClickOpenContactUsDialog = () => {
    setOpenContactUsDialog(true);
  };

  const handleCloseContactUsDialog = () => {
    setOpenContactUsDialog(false);
  };

  const handleClickOpenWhatsNewDialog = () => {
    setOpenWhatsNewDialog(true);
  };

  const handleCloseWhatsNewDialog = () => {
    setOpenWhatsNewDialog(false);
  };

  return (
    <StyledDrawer variant="permanent" open={open}>
      <DrawerHeader />
      <List>
        <ListItem disablePadding sx={{ display: "block" }}>
          <ListItemButton
            href={`/`} // href is possibly not the most efficient way to link to a different route
            sx={{
              minHeight: 50,
              justifyContent: "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: 3,
                justifyContent: "center",
              }}
            >
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding sx={{ display: "block" }}>
          <ListItemButton
            onClick={colorMode.toggleColorMode}
            sx={{
              minHeight: 50,
              justifyContent: "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: 3,
                justifyContent: "center",
              }}
            >
              {theme.palette.mode === "light" ? (
                <DarkModeIcon />
              ) : (
                <LightModeIcon />
              )}
            </ListItemIcon>
            <ListItemText
              primary={`Switch to ${
                theme.palette.mode === "light" ? "dark" : "light"
              } mode`}
            />
          </ListItemButton>
        </ListItem>
        <Divider />
        <ListItem key="Roads" disablePadding sx={{ display: "block" }}>
          <ListItemButton
            // href is possibly not the most efficient way to link to a different route
            href="/roads" // href temporarily links to home if link not provided
            disabled={false}
            sx={{
              minHeight: 50,
              justifyContent: "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: 3,
                justifyContent: "center",
              }}
            >
              <AddRoadIcon />
            </ListItemIcon>
            <ListItemText primary="Roads" />
          </ListItemButton>
        </ListItem>
        <ListItem key="MPO" disablePadding sx={{ display: "block" }}>
          <ListItemButton
            // href is possibly not the most efficient way to link to a different route
            href="/mpo" // href temporarily links to home if link not provided
            disabled={false}
            sx={{
              minHeight: 50,
              justifyContent: "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: 3,
                justifyContent: "center",
              }}
            >
              <AddRoadIcon />
            </ListItemIcon>
            <ListItemText primary="MPO" />
          </ListItemButton>
        </ListItem>
        <ListItem key="Top 100" disablePadding sx={{ display: "block" }}>
          <ListItemButton
            // href is possibly not the most efficient way to link to a different route
            href="/" // href temporarily links to home if link not provided
            disabled={true}
            sx={{
              minHeight: 50,
              justifyContent: "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: 3,
                justifyContent: "center",
              }}
            >
              <FmdGoodIcon />
            </ListItemIcon>
            <ListItemText primary="Top 100" />
          </ListItemButton>
        </ListItem>
        <ListItem key="FIXIT" disablePadding sx={{ display: "block" }}>
          <ListItemButton
            // href is possibly not the most efficient way to link to a different route
            onClick={() => window.open('https://fixit.tti.tamu.edu/dashboard', '_blank')}
            disabled={false}
            sx={{
              minHeight: 50,
              justifyContent: "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: 3,
                justifyContent: "center",
              }}
            >
              <FixitLogo />
            </ListItemIcon>
            <ListItemText primary="FIXIT" />
          </ListItemButton>
        </ListItem>
        <Divider />
        <ListItem key="What's New?" disablePadding sx={{ display: "block" }}>
          <ListItemButton
            onClick={handleClickOpenWhatsNewDialog}
            sx={{
              minHeight: 50,
              justifyContent: "initial",
              px: 2.5,
            }}
          >
            <ListItemText primary="What's New?" />
          </ListItemButton>
        </ListItem>
        <ListItem key="Contact us" disablePadding sx={{ display: "block" }}>
          <ListItemButton
            onClick={handleClickOpenContactUsDialog}
            sx={{
              minHeight: 50,
              justifyContent: "initial",
              px: 2.5,
            }}
          >
            <ListItemText primary="Contact us" />
          </ListItemButton>
        </ListItem>

        <Dialog open={openWhatsNewDialog} onClose={handleCloseWhatsNewDialog}>
          <DialogTitle>What's New?</DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={1} direction="row">
              <Grid item xs={12}>
                <Typography>
                  The website was last updated on May 5th, 2025.
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseWhatsNewDialog}>Close</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openContactUsDialog} onClose={handleCloseContactUsDialog}>
          <DialogTitle>Contact Us</DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={1} direction="row">
              <Grid item xs={6}>
                <Typography variant="subtitle1">
                  <strong>Bill Morgan</strong>
                </Typography>
                <Typography variant="subtitle1">
                  Illinois Department of Transportation (IDOT)
                </Typography>
                <a href={"mailto:william.morgan@illinois.gov"}>
                  william.morgan@illinois.gov
                </a>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle1">
                  <strong>L.D. White</strong>
                </Typography>
                <Typography variant="subtitle1">
                  Texas A&M Transportation Institute (TTI)
                </Typography>
                <a href={"mailto:l-white@tti.tamu.edu"}>l-white@tti.tamu.edu</a>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseContactUsDialog}>Close</Button>
          </DialogActions>
        </Dialog>
      </List>
    </StyledDrawer>
  );
}
